import { createContext, useContext, useEffect, useState } from "react";
import useStateRef from "react-usestateref";
import { getItemFromCache, WallTabsList } from "../utils/wall/wall-constants";
import { getMessageBank } from "../api/wall";
import wall_images from "../utils/wall/wall-imges";
import { useNavigate } from "@remix-run/react";
import { StorageService } from "../utils/StorageUtils";
import { isNotEmptyOrNull } from "../utils/common-utils";

const WallContext = createContext();
export const WallProvider = ({ children }) => {
  const navigate = useNavigate();
  let bgImg = wall_images?.background?.image1;
  const [activityData, setActivityData, activityDataRef] = useStateRef([]);
  const [activityPosts, setActivityPosts, activityPostsRef] = useStateRef([]);
  const [userPosts, setUserPosts, userPostsRef] = useStateRef([]);
  const [selectedTab, setSelectedTab, selectedTabRef] = useStateRef(
    WallTabsList?.[0]?.index
  );
  const [messageBank, setMessageBank, messageBankRef] = useStateRef([]);
  const [selectedBg, setSelectedBg, selectedBgRef] = useStateRef(bgImg);
  const [activity, setActivity, activityRef] = useStateRef({});
  const [post, setPost, postRef] = useStateRef({});
  const [userId, setUserId, userIdRef] = useStateRef("");
  const [selectionDetails, setSectionDetails] = useState({
    userId: 0,
    sectionId: 0,
    schoolId: 0,
    gradeId: 0,
  });

  useEffect(() => {
    handleFetchCache();
  }, []);

  const handleFetchCache = async () => {
    let xUserId = await StorageService.getItem("xUserId");
    let school_info = await getItemFromCache("user_additional_details");
    setUserId(xUserId);
    setSectionDetails({
      userId: xUserId,
      schoolGradeId: school_info?.schoolGradeId || "0",
      schoolId: school_info?.schoolId || "0",
      sectionId: school_info?.sectionId || "0",
      gradeId: school_info?.grade || "0",
      firstName: school_info?.firstName,
      lastName: school_info?.lastName,
      academicYearId: school_info?.academicYearId || "0",
    });

    let post = await getItemFromCache("post");
    setPost(post);
    let activity = await getItemFromCache("activity");
    if (isNotEmptyOrNull(activity)) {
      setActivity(activity);
    }
    setMessageBank(await getMessages());
  };
  const getMessages = async () => {
    let { success, data } = await getMessageBank();
    if (success) {
      return data;
    } else {
      return [];
    }
  };

  const state = {
    setActivityData,
    activityData: activityDataRef?.current,
    selectedTab: selectedTabRef?.current,
    setSelectedTab,
    messageBank: messageBankRef?.current,
    setMessageBank,
    getMessages,
    userPosts: userPostsRef?.current,
    setUserPosts,
    selectedBg: selectedBgRef?.current,
    setSelectedBg,
    activityPosts: activityPostsRef?.current,
    setActivityPosts,
    activity: activityRef?.current,
    setActivity,
    post: postRef?.current,
    setPost,
    userId: userIdRef?.current,
    selectionDetails,
  };
  return <WallContext.Provider value={state}>{children}</WallContext.Provider>;
};

export const useWall = () => {
  return useContext(WallContext);
};
